var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper flex flex-direction flex-sub padding-sm"},[_c('div',{staticClass:"chart-map"},[_c('div',{ref:"map",staticClass:"map"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }